export const convertMonthsToTermsSlug = (months: number) => {
  const term = months >= 12 ? `${months / 12}-years` : `${months}-months`;

  return term;
};
